<template>
    <v-form-group :label="label"
                  :description="description"
                  :error="error"
                  :state="errorState">
        <div v-if="readonly"
             v-html="text"></div>
        <b-form-select
                v-else
                @input="handleInput"
                :value="input"
                :options="options"
                :state="errorState"        />
    </v-form-group>
</template>

<script>
    import field from "../../Mixins/field";

    export default {
        mixins: [field],
        props: ['type', 'options'],
        computed: {
            text() {
                this.options.find(function(option) {
                    return option.value === this.input
                }).text
            }
        }
    }
</script>